<template>
  <div id="app">
    <SGHeader v-if="show_header"></SGHeader>

    <div style="min-height: 500px;">
      <router-view/>
    </div>

    <div class="sg-round-bottom-base" v-if="show_footer">
      <div class="sg-round-bottom">
      </div>
    </div>

    <SGFooter v-if="show_footer"></SGFooter>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    'SGHeader': Header,
    'SGFooter': Footer
  },
  data () {
    return {
      show_header: true,
      show_footer: true
    }
  },
  mounted: function () {
    let currentRoute = this.$router.currentRoute.name

    if (currentRoute === 'Login' || currentRoute === 'Register') {
      this.show_header = false
      this.show_footer = false
    } else {
      this.show_header = true
      this.show_footer = true
    }
  },
  watch: {
    $route (Register) {
      let currentRoute = this.$router.currentRoute.name

      if (currentRoute === 'Login' || currentRoute === 'Register') {
        this.show_header = false
        this.show_footer = false
      } else {
        this.show_header = true
        this.show_footer = true
      }
    }
  },
  methods: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */

  background-color: #f3f3f4;
  color: #2c3e50;

  /* to solve problem that comes from infinite-slider-bar */
  overflow-x: hidden;
  width: 100vw;
  /* END to solve problem that comes from infinite-slider-bar */
}

/* style debuging */
/*div.container {
  border: 0.1px solid red;
}
div.row {
  border: 0.1px solid green;
}
div.col,
div.col-1,
div.col-2,
div.col-3,
div.col-4,
div.col-5,
div.col-6 {
  border: 0.1px solid blueviolet;
}
div, ul, li, a,
img.img-fluid {
  border: 0.1px solid black;
}
.border-solid {
  border: 0.1px solid green !important;
}*/
/* END style debuging */

/* StarGuides Style Standart */
.dropdown.icon {
  display: none;
}
input {
  text-align: center;
}
.text.default {
  color: #8f8f8f !important;
}

button.btn {
  border-radius: 10px !important;
}
.sg-round-box {
  border-radius: 15px !important;
}
.sg-box-shadow {
  /* x,y, blur, spread color */
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
}
.sg-rounded-container {
  background-color: #ffffff;
  border-radius: 15px;

  /* x,y, blur, spread color */
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
}

.sg-round-bottom-base {
  background-color: #233c7c !important;

  height: 20px;
  padding: 0;
}
.sg-round-bottom {
  background-color: #f3f3f4;

  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  height: 20px;
  padding: 0;

}

.sg-badge {
  padding: 0.5em;
  border-radius: 10px;
  text-align: center;
  font-weight: 500;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
}
.sg-badge.on {
  background-color: #f27137;
  color: white;
}
.sg-badge.off {
  background-color: #dce2eb;
  color: black;
}

.sg-backdrop {
  background-color: #00000070;
  height: 100vh;
  width: 100vw;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  scroll-behavior: smooth;
}
/* END StarGuides Style Standart */

/* Global Styling */
.center-base {
  display: flex;
}
.center-base.all {
  justify-content: center;
  align-items: center;
}
.center-base.vertical {
  align-items: center
}
.center-base.horizontal {
  justify-content: center;
}
.center-base.between {
  justify-content: space-between;
}
.center-base.around {
  justify-content: space-around;
}
.center-base.row {
  flex-direction: row;
}

.modal-backdrop {
  opacity: 0.25;
}

.cursor-pointer{
  cursor: pointer;
}
/* END Global Styling */
</style>



// WEBPACK FOOTER //
// src/App.vue